var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAds2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.748,
    height: 37.748,
    viewBox: "0 0 37.748 37.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_volume-low",
    "data-name": "vuesax/linear/volume-low",
    transform: "translate(-556 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "volume-low",
    transform: "translate(556 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,9.379V15.8q0,4.813,4.813,4.813h2.3a3.232,3.232,0,0,1,1.7.488l4.687,2.925c4.058,2.532,7.361.692,7.361-4.089V5.227c0-4.781-3.319-6.622-7.361-4.089L8.808,4.079a3.273,3.273,0,0,1-1.7.488h-2.3Q0,4.566,0,9.379Z",
    transform: "translate(3.146 6.286)",
    fill: "none",
    stroke: "#1b7afa",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H6.291",
    transform: "translate(28.311 18.874)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H6.291",
    transform: "matrix(0.875, 0.485, -0.485, 0.875, 28.705, 23.64)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H6.291",
    transform: "matrix(0.875, -0.485, 0.485, 0.875, 28.705, 14.108)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H37.748V37.748H0Z",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAds2);
export default __webpack_public_path__ + "static/media/ads2.d7f2fd27d7f7e6a9548fb2f6d5541dfb.svg";
export { ForwardRef as ReactComponent };